import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { stepDecrement, stepReset } from '../../redux/steps'
import { useModal } from '../../hooks/useModal'
import CheckIcon from '../../assets/icons/small_check.svg'
import { useHistory } from 'react-router-dom'
import {
  Container,
  ContainerStepperInfo,
  CaseNumberTitle,
  CaseNumberCounter,
  CancelCase,
  StepperWrapper,
  Step,
  Connector,
  Icon,
  StepperContainer
} from './styles'

const NEW_PATIENT_STEPS = [
  { id: 1, description: 'Identificación de paciente' },
  { id: 2, description: 'Datos del paciente' }
]

export function NewPatientStepper () {
  const { user } = useSelector(state => state)
  const [CASE_NUMBER_MOCKED] = useState(user && user.evaluations.length + 1)
  const { current: currentStep } = useSelector(state => state.steps)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleStepClick = ({ step }) => {
    if (currentStep === 1 || step.id >= currentStep) {

    } else {
      for (let i = currentStep; i > step.id; i--) {
        dispatch(stepDecrement())
      }
    }
  }

  const handleCancelPatient = () => {
    dispatch(stepReset())
    history.push('/home')
  }

  return (
    <Container>
      <ContainerStepperInfo>
        <CaseNumberTitle> Nuevo paciente </CaseNumberTitle>
        {/* <CaseNumberCounter> n° {CASE_NUMBER_MOCKED} </CaseNumberCounter> */}
      </ContainerStepperInfo>

      <StepperContainer>
        <StepperWrapper>
          {NEW_PATIENT_STEPS.map((step, index) => (
            <React.Fragment key={step.id}>
              <Step active={step.id === currentStep} completed={currentStep > step.id} clickeable text={step.description} onClick={() => handleStepClick({ step })}>
                {currentStep > step.id ? <Icon src={CheckIcon} alt='check' /> : step.id}
              </Step>
              {index < NEW_PATIENT_STEPS.length - 1 && <Connector />}
            </React.Fragment>
          ))}
        </StepperWrapper>
      </StepperContainer>

      <ContainerStepperInfo>
        <CancelCase onClick={handleCancelPatient}> Cancelar </CancelCase>
      </ContainerStepperInfo>
    </Container>
  )
}

export default NewPatientStepper
